import { useState } from 'react';
import { Box } from '@smartfm/ui/components/Box';
import { Stack } from '@smartfm/ui/components/Stack';
import { ConnectedBuildingSelector } from './BuildingSelector';
import { ConnectedClientSelector } from './ClientSelector';
import { setDefaultDashboard } from '@/services/DashboardService';
import { useClientId } from '@smartfm/container/hooks/useClientId';
import { queryClient } from '@/context/query';

type Props = {
  defaultData: {
    defaultClient: string;
    defaultBuildingsMap: Map<string, { site: string; default: boolean }>;
  };
};

export function ClientBuildingSelector({ defaultData }: Props) {
  const [clientId] = useClientId();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [defaultClient, setDefaultClient] = useState<string>(
    defaultData.defaultClient || ''
  );

  const handleSetDefaultClient = async (clientId: string) => {
    try {
      setLoading(true);
      setDefaultClient(clientId);
      await setDefaultDashboard(
        clientId,
        defaultData.defaultBuildingsMap.get(clientId)?.site,
        true
      );
      await queryClient.invalidateQueries({
        queryKey: ['getDefaultSiteForUser'],
      });
    } catch (error) {
      console.error('Error setting default client:', error);
    } finally {
      setLoading(false);
    }
  };
  const defaultBuilding = defaultData?.defaultBuildingsMap.get(clientId)
    ?.default
    ? defaultData.defaultBuildingsMap.get(clientId)?.site
    : '';
  return (
    <Stack
      direction='row'
      alignItems='center'
    >
      {clientId && clientId !== 'all' && (
        <>
          <ConnectedBuildingSelector
            position='bottom_end'
            clientId={clientId}
            defaultBuilding={defaultBuilding}
          />
          <Box
            sx={{
              height: '100%',
              opacity: 0.6,
              paddingLeft: 1.5,
              paddingRight: 3,
            }}
          >
            {' | '}
          </Box>
        </>
      )}
      <ConnectedClientSelector
        position='bottom_end'
        clientId={clientId}
        onDefaultClientChange={handleSetDefaultClient}
        defaultClient={defaultClient}
        defaultBuildingsMap={defaultData.defaultBuildingsMap}
        isLoading={isLoading}
      />
    </Stack>
  );
}
